// Desc: Footer for the application
const Footer = () => {
    return (
        <footer
            className="text-center"
            style={{
                'textAlign': 'right',
            }}>

            <p>&copy; 2023 Decept10</p>
        </footer>
    )
}

export default Footer;